import { createSlice } from "@reduxjs/toolkit";
import { STORAGE_SUBTAB_ID, STORAGE_TAB_ID, STORAGE_SSUB_ID } from "config/const/global";


// state about sidebar
const sidebarSlice = createSlice({
    name: "sidebar",
    initialState: {
        toggleSidebar: false, // indicate the sidebar' state, collapse or expand
        tabOpenId: +localStorage.getItem(STORAGE_TAB_ID) || 1, // the sidebar's main tab id
        subtabOpenId: +localStorage.getItem(STORAGE_SUBTAB_ID) || 1, // the subtab's id of above main tab
        ssubOpenId: +localStorage.getItem(STORAGE_SSUB_ID) || 1 // the subtab's id of above main tab
    },
    reducers: {
        // sidebar handler
        toggleSidebar(state, action) {
            state.toggleSidebar = !state.toggleSidebar
        },
        // sidebar main tab setter
        setTabById(state, action) {
            state.tabOpenId = action.payload
            state.subtabOpenId = 1
            localStorage.setItem(STORAGE_TAB_ID, action.payload)
        },
        // sidebar subtab setter
        setSubtabById(state, action) {
            state.subtabOpenId = action.payload
            localStorage.setItem(STORAGE_SUBTAB_ID, action.payload)
        },
        // sidebar subtab's subtab setter
        setSsubById(state, action) {
            state.ssubOpenId = action.payload
            localStorage.setItem(STORAGE_SSUB_ID, action.payload)
        }
    }
})

export const {
    toggleSidebar,
    setTabById,
    setSubtabById,
    setSsubById
} = sidebarSlice.actions
export default sidebarSlice